"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertControl = void 0;
class AlertControl {
    constructor() {
        this.closeButton = $('.alertClose');
        this.closeTarget = $('.alertArea');
        this.headerLine = $('header .contentHolder');
        this.closeButton.on('click', (e) => {
            this.closeTarget.hide();
        });
    }
}
exports.AlertControl = AlertControl;
